import { Button, Dropdown, DropDownProps, Radio, RadioChangeEvent, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { lowerCase, startCase } from "lodash";

const style: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
};

type StatusSwitchProps = {
  onChange: ((e: RadioChangeEvent) => void) | undefined;
  options: Record<string, string | undefined>;
  value: string;
} & DropDownProps;


export function StatusSwitch(props: StatusSwitchProps) {
  const optionsAsArray = Object.keys(props.options).map((key) => ({
    label: (
      <Tag bordered={false} className="tail-rounded-full" color={props.options[key ]}>
        {startCase(lowerCase(key))} ●
      </Tag>
    ),
    value: key,
    color: props.options[key as keyof typeof props.options],
  }));

  return (
    <Dropdown
      disabled={props.disabled}
      dropdownRender={(menu)=>
        <div style={{ padding: 10, background: "#fff", borderRadius: 8, boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
          <Radio.Group
            style={style}
            onChange={(e)=>props.onChange && props.onChange(e)}
            value={props.value}
            options={optionsAsArray}
          />
        </div>
      }
      trigger={['click']}
    >
      <Button disabled={props.disabled} type="text" className="tail-flex tail-w-full tail-px-1 tail-justify-between">
        <span className="tail-grow tail-text-left">
        <Tag bordered={false} className="tail-rounded-full" color={props.options[props.value]}>
          {startCase(lowerCase(props.value))} ●
        </Tag>
        </span>
        <EditOutlined />
      </Button>
    </Dropdown>
  );
}